import { TrashIcon } from "../images";
import { CustomButton } from "../ui/CustomButton";
import { ReuseModal } from "../ui";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CustomToast } from "../ui/CustomToast";
import { useDeleteProductMutation } from "../../api";
import { AppRoutes } from "../../types/enums";
import { useNavigate } from "react-router-dom";
import { Stack, Typography } from "@mui/material";

export const DeleteProductBtn = ({ campaign_id }: { campaign_id: string }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [deleteProduct, { isSuccess, isLoading, error }] =
    useDeleteProductMutation();

  useEffect(() => {
    if (error) {
      toast.error(
        <CustomToast
          type={"error"}
          text={"Your last changes were not saved. Please try again"}
          title={"Something went wrong"}
        />,
      );
      setIsOpen(false);
    }
  }, [error]);

  useEffect(() => {
    if (isSuccess) {
      toast.success(
        <CustomToast
          type={"success"}
          text={"All campaign information was successfully deleted"}
          title={"Campaign deleted"}
        />,
      );
      navigate(AppRoutes.CAMPAIGNS);
    }
  }, [isSuccess]);

  return (
    <>
      <CustomButton
        onClick={() => setIsOpen(true)}
        variant="contained"
        fullWidth
        textColor="#FFFFFF"
        customColor="#C0392B"
        type="button"
        startIcon={<TrashIcon color="#FFFFFF" />}
        sx={{ height: "36px" }}
      >
        Delete Campaign
      </CustomButton>

      <ReuseModal
        icon="warn"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={() => deleteProduct(campaign_id)}
        title="Delete Campaign"
        customText={
          <Stack gap="36px">
            <Typography variant="body1" color="text.secondary">
              Are you sure you want to delete this campaign and all information
              about it?
            </Typography>
            <Typography variant="body1" color="text.secondary">
              All data about campaign will be
              <strong>{" permanently deleted."}</strong>
            </Typography>
          </Stack>
        }
        isDisabled={isLoading}
        isLoading={isLoading}
        isDisabledCancelBtn={isLoading}
        submitBtnText="Delete"
        maxWidth="430px"
      />
    </>
  );
};
